import React, { useState } from 'react'
import { TouchableOpacity, ActivityIndicator, TextStyle, ViewStyle } from 'react-native'
import { useHistory } from 'react-router'
import { Button as MuiButton, InputAdornment, TextField } from '@mui/material'
import { ChevronLeftRounded, EmailRounded, PersonRounded } from '@mui/icons-material'
import { useStores } from '@trivie/core'
import {
  Button,
  color,
  iconApple,
  iconGoogle,
  iconMicrosoft,
  SvgIcon,
  Text,
} from '@trivie/ui-mobile'

export const SignupScreen = () => {
  const { userStore } = useStores()

  const history = useHistory()

  const { email } = userStore

  const [formEmail, setFormEmail] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [showFirstLast, setShowFirstLast] = useState(false)

  const onSubmit = () => {
    userStore.setEmail(formEmail)
    setShowFirstLast(true)
  }

  const [loader, setLoader] = useState(false)
  const signup = () => {
    setLoader(true)
    userStore
      .whitelabelSignup(
        {
          email,
          first_name: firstName,
          last_name: lastName,
          app_id: 'com.trivie.engage.aha',
        },
        'com.trivie.engage.aha',
      )
      .then((data: any) => {
        userStore.loginWorkspace(btoa(data.access_token), data.access_code, () =>
          history.replace('/library'),
        )
      })
  }

  return (
    <div style={ROOT}>
      <div style={CONTAINER}>
        <div style={CONTENT}>
          <div style={HEADER}>
            <Text style={HEADLINE} tx="Onboarding.newSignup" variant="headline" />
            <Text
              variant="titleMedium"
              style={TAGLINE}
              text={
                showFirstLast
                  ? 'Please tell us a little about yourself.'
                  : 'Sign up for a new AHA Booster Account'
              }
            />
          </div>
          {showFirstLast && (
            <>
              <TextField
                variant="standard"
                required
                onChange={(e: any) => setFirstName(e.target.value)}
                style={{ width: 335, marginBottom: 51 }}
                size="small"
                InputProps={{
                  style: { paddingBottom: 8 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonRounded htmlColor={color.black} />
                    </InputAdornment>
                  ),
                }}
                placeholder="Your First Name"
              />
              <TextField
                variant="standard"
                required
                onChange={(e: any) => setLastName(e.target.value)}
                style={{ width: 335, marginBottom: 51 }}
                size="small"
                InputProps={{
                  style: { paddingBottom: 8 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonRounded htmlColor={color.black} />
                    </InputAdornment>
                  ),
                }}
                placeholder="Your Last Name"
              />
              <Button
                variant="secondary"
                accessibilityRole="button"
                accessibilityLabel="Create Account"
                disabled={!firstName || !lastName || loader}
                style={{
                  ...SUBMIT,
                  marginBottom: 50,
                }}
                tx="Onboarding.SignUp.createAccount"
                onPress={() => signup()}
              >
                {loader && <ActivityIndicator color="#fff" />}
              </Button>
            </>
          )}
          {!showFirstLast && (
            <>
              <TextField
                variant="standard"
                type="email"
                required
                onChange={(e: any) => {
                  setFormEmail(e.target.value)
                }}
                value={formEmail}
                style={{ width: 335, marginBottom: 51 }}
                size="small"
                InputProps={{
                  style: { paddingBottom: 8 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailRounded htmlColor={color.black} />
                    </InputAdornment>
                  ),
                }}
                helperText={
                  formEmail && !formEmail.includes('@') ? 'Enter a valid email address.' : ''
                }
                placeholder="Your Email Address"
                error={formEmail !== '' && !formEmail.includes('@')}
              />
              <Button
                accessibilityRole="button"
                accessibilityLabel="Sign Up Via Email"
                disabled={!formEmail || !formEmail.includes('@')}
                style={{
                  ...SUBMIT,
                  marginBottom: 50,
                  backgroundColor:
                    !formEmail || !formEmail?.includes('@') ? color.shade20 : color.blue,
                  opacity: !formEmail || !formEmail?.includes('@') ? 0.4 : 1.0,
                }}
                tx="Onboarding.SignUp.emailSignUp"
                onPress={() => onSubmit()}
              />
              <div style={DIVIDER}>
                <div style={{ height: 1, width: '100%', backgroundColor: color.shade20 }} />
                <Text variant="titleEmphasized" tx="Common.or" style={{ marginHorizontal: 10 }} />
                <div style={{ height: 1, width: '100%', backgroundColor: color.shade20 }} />
              </div>
              <div style={{ marginBottom: 72 }}>
                <TouchableOpacity
                  accessibilityRole="button"
                  accessibilityLabel="Sign In"
                  style={SSO_BTN}
                  onPress={() =>
                    window.location.replace(
                      `${process.env.REACT_APP_SSO_MS_URL}?intent=signup&app_id=com.trivie.engage.aha`,
                    )
                  }
                >
                  <div style={{ marginTop: 4, marginRight: 15 }}>
                    <SvgIcon src={iconMicrosoft} />
                  </div>
                  <Text style={SSO_BTN_TXT} tx="Onboarding.Login.microsoftContinue" />
                </TouchableOpacity>
                <TouchableOpacity
                  accessibilityRole="button"
                  accessibilityLabel="Sign In"
                  style={SSO_BTN}
                  onPress={() =>
                    window.location.replace(
                      `${process.env.REACT_APP_SSO_GOOG_URL}?intent=signup&app_id=com.trivie.engage.aha`,
                    )
                  }
                >
                  <div style={{ marginTop: 4, marginRight: 15 }}>
                    <SvgIcon src={iconGoogle} />
                  </div>
                  <Text style={SSO_BTN_TXT} tx="Onboarding.Login.googleContinue" />
                </TouchableOpacity>

                <TouchableOpacity
                  accessibilityRole="button"
                  accessibilityLabel="Sign In"
                  style={{ ...SSO_BTN, marginBottom: 32 }}
                  onPress={() =>
                    window.location.replace(
                      `${process.env.REACT_APP_SSO_APPLE_URL}?intent=signup&app_id=com.trivie.engage.aha`,
                    )
                  }
                >
                  <div style={{ top: 12, marginRight: 15 }}>
                    <SvgIcon src={iconApple} />
                  </div>
                  <Text style={{ ...SSO_BTN_TXT }} tx="Onboarding.Login.appleContinue" />
                </TouchableOpacity>
                {/* <TouchableOpacity style={SSO_BTN} onPress={handleSubmit(onSubmit)}>
              <View style={{ top: 12, right: 15 }}>
                <SvgIcon src={iconLock} color="#000" />
              </View>
              <Text style={SSO_BTN_TXT} text={'Continue with SSO'} />
            </TouchableOpacity> */}
              </div>
            </>
          )}
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
            <MuiButton
              onClick={() => {
                if (showFirstLast) {
                  setShowFirstLast(false)
                } else {
                  history.replace('/login')
                }
              }}
              style={{ textTransform: 'none' }}
              startIcon={<ChevronLeftRounded style={{ color: color.shade70, fontSize: 24 }} />}
            >
              Back
            </MuiButton>
          </div>
        </div>
      </div>
    </div>
  )
}

const ROOT: React.CSSProperties = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
}
const CONTAINER: React.CSSProperties = {
  flexDirection: 'column',
  flex: 1,
  display: 'flex',
  maxHeight: 576,
  justifyContent: 'space-evenly',
  width: '100%',
  alignSelf: 'center',
}
const CONTENT: React.CSSProperties = {
  height: '100%',
  flex: 1,
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignSelf: 'center',
}
const HEADER: React.CSSProperties = { minWidth: 319, flexDirection: 'column', display: 'flex' }
const SUBMIT: ViewStyle = {
  marginHorizontal: 20,
  backgroundColor: color.palette.blue,
  width: 335,
  alignSelf: 'center',
  marginBottom: 50,
}
const TAGLINE: TextStyle = {
  opacity: 0.5,
  textAlign: 'center',
  marginBottom: 50,
  width: 319,
}
const HEADLINE: TextStyle = { textAlign: 'center', marginBottom: 12 }
const SSO_BTN: ViewStyle = {
  marginBottom: 12,
  width: 335,
  backgroundColor: color.white,
  borderColor: color.shade20,
  borderWidth: 1,
  borderRadius: 16,
  height: 52,
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
}
const SSO_BTN_TXT: TextStyle = {
  fontSize: 17,
  fontWeight: '600',
  color: 'rgba(0,0,0,0.54)',
  lineHeight: 22.61,
}
const DIVIDER: React.CSSProperties = {
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  width: 375,
  paddingRight: 20,
  paddingLeft: 20,
  marginBottom: 40,
}
